import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { DemoPublishForm } from './DemoPublishForm';
import { DemoSettingsForm } from './DemoSettingsForm';

export const useDemoExport: ExportFormHook<any, socialExport.DemoSettingsDto> = () => {
  return {
    PublishForm: DemoPublishForm,
    SettingsForm: DemoSettingsForm,
  };
};
